// Kept byte-for-byte in sync with User.TIMEZONE_CHOICES in
// backend/apps/users/models.py. The backend validates; this list only decides
// what the selector offers.
export const DEFAULT_TIMEZONE = 'America/Monterrey';

export const SUPPORTED_TIMEZONES = [
  { value: 'America/Monterrey', labelKey: 'common.timezones.monterrey' },
  { value: 'America/Cancun', labelKey: 'common.timezones.cancun' },
  { value: 'America/Chihuahua', labelKey: 'common.timezones.chihuahua' },
  { value: 'America/Tijuana', labelKey: 'common.timezones.tijuana' },
  { value: 'UTC', labelKey: 'common.timezones.utc' },
  { value: 'America/New_York', labelKey: 'common.timezones.usEastern' },
  { value: 'America/Chicago', labelKey: 'common.timezones.usCentral' },
  { value: 'America/Denver', labelKey: 'common.timezones.usMountain' },
  { value: 'America/Los_Angeles', labelKey: 'common.timezones.usPacific' },
];

export const isSupportedTimezone = (value) =>
  SUPPORTED_TIMEZONES.some((zone) => zone.value === value);

/** The browser's zone when we support it, otherwise the default. */
export const detectBrowserTimezone = () => {
  try {
    const detected = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return isSupportedTimezone(detected) ? detected : DEFAULT_TIMEZONE;
  } catch (err) {
    return DEFAULT_TIMEZONE;
  }
};

/** Saved preference wins, then the browser, then the default. */
export const resolveTimezone = (saved) =>
  isSupportedTimezone(saved) ? saved : detectBrowserTimezone();
